<template>
  <section class="form-list">
    <div v-show="isLoading || isSaving || isLoadingError" class="loading-box">
      <div class="loading-main" @click="load">
        <svg v-show="isLoading || isSaving" class="loading-circular" viewBox="25 25 50 50">
          <circle class="loading-path" cx="50" cy="50" r="20" fill="none"/>
        </svg>
        <div v-show="isLoadingError" class="loading-refresh">
          <i class="el-icon-refresh"/>
        </div>
        <div v-show="isLoadingError" class="loading-text">
          数据加载失败，点击重新尝试
        </div>
      </div>
    </div>

    <el-form
      class="form form-max"
      ref="form"
      :model="report"
      label-position="left"
      label-width="160px"
    >
      <el-form-item v-if="isAdministrator" label="所属门店">
        <v-select-store v-model="report.store_id" :disabled="true" class="expenditure-input"/>
      </el-form-item>
      <el-form-item label="所属月份">
        <el-date-picker
          v-model="report.report_date"
          :picker-options="pickerOptions"
          :disabled="true"
          type="month"
          value-format="timestamp"
          placeholder="请选择所属月份"
          class="expenditure-input"
        />
      </el-form-item>
      <el-form-item label="添加时间">{{ report.add_time | timeToYmdHi }}</el-form-item>

      <div class="table-box">
        <div v-if="newCards.length" class="table-title table-title-hover" @click="() => isShowNewCards = !isShowNewCards">
          新生收入统计
          <span class="list-count">{{ newCards.length }}</span>
          <template v-if="new_cards_del_count">（包含 <span class="list-count">{{ new_cards_del_count }}</span> 笔退卡 ）</template>
          <div :class="`arrow-box ${isShowNewCards ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          新生收入统计
          <span class="list-count">{{ newCards.length }}</span>
          <template v-if="new_cards_del_count">（包含 <span class="list-count">{{ new_cards_del_count }}</span> 笔退卡 ）</template>
        </div>
        <el-table
          v-show="isShowNewCards"
          :data="newCards"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
          :row-class-name="tableRowClassName"
        >
          <v-column-time value="录入时间" sortable="" align="center"/>
          <v-column-time value="办卡日期" field="register_time" time-format="timeToYmd" sortable="" align="center"/>
          <el-table-column label="课卡 ID" align="center" width="80">
            <template v-slot="{ row }">{{ row.id }}</template>
          </el-table-column>
          <v-column-student label="所属学员" link-page-id="student_id" align="center"/>
          <el-table-column label="课卡名称" align="center" prop="card_name"/>
          <el-table-column label="收入金额" align="center" prop="actual_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ row.actual_payment | toYuan }}</span>
              <span v-if="row.is_del" class="danger-color">（已退卡）</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="oldCards.length" class="table-title table-title-hover" @click="() => isShowOldCards = !isShowOldCards">
          老生收入统计
          <span class="list-count">{{ oldCards.length }}</span>
          <template v-if="old_cards_del_count">（包含 <span class="list-count">{{ old_cards_del_count }}</span> 笔退卡 ）</template>
          <div v-if="oldCards.length" :class="`arrow-box ${isShowOldCards ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          老生收入统计
          <span class="list-count">{{ oldCards.length }}</span>
          <template v-if="old_cards_del_count">（包含 <span class="list-count">{{ old_cards_del_count }}</span> 笔退卡 ）</template>
        </div>
        <el-table
          v-show="isShowOldCards"
          :data="oldCards"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
          :row-class-name="tableRowClassName"
        >
          <v-column-time value="录入时间" sortable="" align="center"/>
          <v-column-time value="办卡日期" field="register_time" time-format="timeToYmd" sortable="" align="center"/>
          <el-table-column label="课卡 ID" align="center" width="80">
            <template v-slot="{ row }">{{ row.id }}</template>
          </el-table-column>
          <v-column-student label="所属学员" link-page-id="student_id" align="center"/>
          <el-table-column label="课卡名称" align="center" prop="card_name"/>
          <el-table-column label="收入金额" align="center" prop="actual_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ row.actual_payment | toYuan }}</span>
              <span v-if="row.is_del" class="danger-color">（已退卡）</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="otherIncomes.length" class="table-title table-title-hover" @click="() => isShowOtherIncomes = !isShowOtherIncomes">
          其他收入统计
          <span class="list-count">{{ otherIncomes.length }}</span>
          <div v-if="otherIncomes.length" :class="`arrow-box ${isShowOtherIncomes ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          其他收入统计
          <span class="list-count">{{ otherIncomes.length }}</span>
        </div>
        <el-table
          v-show="isShowOtherIncomes"
          :data="otherIncomes"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="录入时间" sortable="" align="center"/>
          <v-column-time value="收入日期" field="report_date" time-format="timeToYmd" sortable="" align="center"/>
          <el-table-column label="收入名称" align="center" prop="title"/>
          <el-table-column label="收款方式" align="center">
            <template v-slot="{ row }">
              <span>{{ findPaymentModeName(row.card_payment_mode_id) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收入金额" align="center" prop="actual_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ row.actual_payment | toYuan }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="updateIncomes.length" class="table-title table-title-hover" @click="() => isShowUpdateIncomes = !isShowUpdateIncomes">
          修改课卡补差价收入统计
          <span class="list-count">{{ updateIncomes.length }}</span>
          <div v-if="updateIncomes.length" :class="`arrow-box ${isShowUpdateIncomes ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          修改课卡补差价收入统计
          <span class="list-count">{{ updateIncomes.length }}</span>
        </div>
        <el-table
          v-show="isShowUpdateIncomes"
          border
          fit
          highlight-current-row
          :data="updateIncomes"
          class="del-card-table store-income-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="审核时间" fixed="left" align="center"/>
          <v-column-admin align="center" label="审核人"/>
          <v-column-avatar align="center" label="申请人" avatarKey="apply_administrator_avatar" nicknameKey="apply_administrator_nickname"/>
          <v-column-student link-page-id="student_id" align="center" label="课卡所属学员"/>
          <el-table-column label="补差价收入" align="center" prop="update_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ row.update_payment | toYuan }}</span>
            </template>
          </el-table-column>
          <el-table-column label="补差价支付方式" align="center">
            <template v-slot="{ row }">
              <span>{{ findPaymentModeName(row.update_payment_mode) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="reservationIncomes.length" class="table-title table-title-hover" @click="() => isShowReservationIncomes = !isShowReservationIncomes">
          小程序预约收入统计
          <span class="list-count">{{ reservationIncomes.length }}</span>
          <template v-if="reservation_income_del_count">（包含 <span class="list-count">{{ reservation_income_del_count }}</span> 笔退款 ）</template>
          <div :class="`arrow-box ${isShowReservationIncomes ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          小程序预约收入统计
          <span class="list-count">{{ reservationIncomes.length }}</span>
          <template v-if="reservation_income_del_count">（包含 <span class="list-count">{{ reservation_income_del_count }}</span> 笔退款 ）</template>
        </div>
        <el-table
          v-show="isShowReservationIncomes"
          :data="reservationIncomes"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
          :row-class-name="reservationIncomeTableRowClassName"
        >
          <v-column-time field="success_time_int" value="支付时间" fixed="left" align="center"/>
          <el-table-column label="订单总金额" align="center" prop="total" type="money">
            <template v-slot="{ row }">
              <span>{{ row.total | toYuan }}</span>
              <span v-if="row.is_refund" class="danger-color">（已申请退款）</span>
            </template>
          </el-table-column>
          <v-column-student link-page-id="student_id" align="center" label="下单学员"/>
          <el-table-column label="微信支付订单号" align="center" prop="transaction_id" type="isNotSummary"/>
          <el-table-column label="预约课程/专栏" align="center">
            <template v-slot="{ row }">
              <router-link
                v-if="row.course_id"
                class="primary-color"
                :to="RouteConfig.courseManage.to(row.course_id)"
              >{{ row.course_name }}</router-link>
              <router-link
                v-else
                class="primary-color"
                :to="RouteConfig.courseColumnManage.to(row.course_column_id)"
              >{{ row.course_column_name }}</router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="delCards.length" class="table-title table-title-hover" @click="() => isShowDelCards = !isShowDelCards">
          退卡统计
          <span class="list-count-pay">{{ delCards.length }}</span>
          <div v-if="delCards.length" :class="`arrow-box ${isShowDelCards ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          退卡统计
          <span class="list-count-pay">{{ delCards.length }}</span>
        </div>
        <el-table
          v-show="isShowDelCards"
          :data="delCards"
          border
          fit
          highlight-current-row
          class="del-card-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="退卡时间" align="center"/>

          <v-column-admin label="退卡管理员" align="center"/>
          <el-table-column label="退卡原因" prop="del_remark" align="center"/>

          <el-table-column label="退款金额" align="center" prop="del_payment" type="money">
            <template v-slot="{ row }">
              {{ row.del_payment | toYuan }}
            </template>
          </el-table-column>

          <el-table-column label="原因截图" align="center">
            <template v-slot="{ row }">
              <el-image
                v-if="row.del_cover"
                :src="row.del_cover"
                style="width: 60px;height: 60px;"
                fit="cover"
              />
            </template>
          </el-table-column>

          <v-column-student label="所属学员" link-page-id="student_id" align="center"/>
          <el-table-column label="课卡名称" prop="card_name" align="center"/>
          <v-column-time value="办卡日期" field="register_time" time-format="timeToYmd" sortable="" align="center"/>
          <el-table-column label="有效次数" align="center">
            <template v-slot="{ row }">
              {{ row.expire_number | toYuan }}
            </template>
          </el-table-column>
          <el-table-column label="有效日期" align="center">
            <template v-slot="{ row }">
              {{ row.expire_time | timeToYmd }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="report.update_pay_count" class="table-title table-title-hover" @click="() => isShowUpdatePays = !isShowUpdatePays">
          修改课卡补差价支出统计
          <span class="list-count">{{ report.update_pay_count }}</span>
          <div v-if="report.update_pay_count" :class="`arrow-box ${isShowUpdatePays ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          修改课卡补差价支出统计
          <span class="list-count-pay">{{ report.update_pay_count }}</span>
        </div>
        <el-table
          v-show="isShowUpdatePays"
          :data="updatePays"
          border
          fit
          highlight-current-row
          class="del-card-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="审核时间" fixed="left" align="center"/>
          <v-column-admin align="center" label="审核人"/>
          <v-column-avatar align="center" label="申请人" avatarKey="apply_administrator_avatar" nicknameKey="apply_administrator_nickname"/>
          <v-column-student link-page-id="student_id" align="center" label="课卡所属学员"/>
          <el-table-column label="补差价支出" align="center" prop="update_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ -row.update_payment | toYuan }}</span>
            </template>
          </el-table-column>
          <el-table-column label="补差价支付方式" align="center">
            <template v-slot="{ row }">
              <span>{{ findPaymentModeName(row.update_payment_mode) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="report.reservation_pay_count" class="table-title table-title-hover" @click="() => isShowReservationPays = !isShowReservationPays">
          小程序预约退款支出统计
          <span class="list-count">{{ report.reservation_pay_count }}</span>
          <div v-if="report.reservation_pay_count" :class="`arrow-box ${isShowReservationPays ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          小程序预约退款支出统计
          <span class="list-count-pay">{{ report.reservation_pay_count }}</span>
        </div>
        <el-table
          v-show="isShowReservationPays"
          :data="reservationPays"
          border
          fit
          highlight-current-row
          class="del-card-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="退款时间" field="success_time_int" fixed="left" align="center"/>
          <v-column-student label="退款学员" link-page-id="student_id" align="center"/>
          <el-table-column label="微信支付订单号" align="center" prop="transaction_id" type="isNotSummary"/>
          <el-table-column label="订单总金额" align="center">
            <template v-slot="{ row }">
              <span>{{ row.total | toYuan }}</span>
            </template>
          </el-table-column>
          <el-table-column label="退款金额" align="center" prop="payer_refund" type="money">
            <template v-slot="{ row }">
              <span class="pay-count">{{ row.payer_refund | toYuan }}</span>
            </template>
          </el-table-column>
          <el-table-column label="退款课程/专栏" align="center">
            <template v-slot="{ row }">
              <router-link
                v-if="row.course_id"
                class="primary-color"
                :to="RouteConfig.courseManage.to(row.course_id)"
              >{{ row.course_name }}</router-link>
              <router-link
                v-else
                class="primary-color"
                :to="RouteConfig.courseColumnManage.to(row.course_column_id)"
              >{{ row.course_column_name }}</router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="report.invoice_count" class="table-title table-title-hover" @click="() => isShowInvoices = !isShowInvoices">
          发票统计
          <span class="list-count-pay">{{ report.invoice_count }}</span>
          <div v-if="report.invoice_count" :class="`arrow-box ${isShowInvoices ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          发票统计
          <span class="list-count-pay">{{ report.invoice_count }}</span>
        </div>
        <el-table
          v-if="isShowInvoices"
          :data="invoices"
          border
          fit
          highlight-current-row
          class="del-card-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="申请时间" sortable="" align="center"/>
          <v-column-avatar label="申请人员" avatar-key="admin_avatar" nickname-key="admin_nickname" align="center"/>
          <el-table-column label="课卡 ID" width="150" align="center">
            <template v-slot="{ row }">
              {{ row.card_id }}
            </template>
          </el-table-column>
          <el-table-column label="发票对象类型" width="150" prop="updateState" align="center">
            <template v-slot="{ row }">
              {{ row.is_personal ? '个人' : '公司'}}
            </template>
          </el-table-column>
          <el-table-column label="发票对象名称" width="150" prop="invoice_name" align="center"/>
          <el-table-column label="开票金额" width="150" prop="amount" type="money" align="center">
            <template v-slot="{ row }">
              {{ row.amount | toYuan }}
            </template>
          </el-table-column>
          <el-table-column label="税额" prop="tax_amount" type="money" align="center">
            <template v-slot="{ row }">
              {{ row.tax_amount | toYuan }}
            </template>
          </el-table-column>

        </el-table>
      </div>



      <div class="table-box">
        <h3>收入统计</h3>

        <div class="flex-wrap">
          <el-form-item label="新生收入笔数" label-width="180px" class="income-item">
            <v-input-number v-model="report.new_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
          </el-form-item>
          <el-form-item label="新生收入金额" label-width="180px" class="income-item">
            <v-input-money class="income-input" v-model="report.new_income" :is-show-suffix="true"/>
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="老生收入笔数" label-width="180px" class="income-item">
            <v-input-number v-model="report.old_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
          </el-form-item>
          <el-form-item label="老生收入金额" label-width="180px" class="income-item">
            <v-input-money class="income-input" v-model="report.old_income" :is-show-suffix="true"/>
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="试课收入笔数" label-width="180px" class="income-item">
            <v-input-number v-model="report.trial_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
          </el-form-item>
          <el-form-item label="试课收入金额" label-width="180px" class="income-item">
            <v-input-money class="income-input" v-model="report.trial_income" :is-show-suffix="true"/>
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="课次券收入笔数" label-width="180px" class="income-item">
            <v-input-number v-model="report.card_ticket_income_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
          </el-form-item>
          <el-form-item label="课次券收入金额" label-width="180px" class="income-item">
            <v-input-money class="income-input" v-model="report.card_ticket_income" :is-show-suffix="true"/>
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="购买代金券收入笔数" label-width="180px" class="income-item">
            <v-input-number v-model="report.voucher_income_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
          </el-form-item>
          <el-form-item label="购买代金券收入金额" label-width="180px" class="income-item">
            <v-input-money class="income-input" v-model="report.voucher_income" :is-show-suffix="true"/>
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="修改课卡补差价收入笔数" label-width="180px" class="income-item">
            <v-input-number v-model="report.update_income_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
          </el-form-item>
          <el-form-item label="修改课卡补差价收入金额" label-width="180px" class="income-item">
            <v-input-money class="income-input" v-model="report.update_income" :is-show-suffix="true"/>
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="小程序预约收入笔数" label-width="180px" class="income-item">
            <v-input-number v-model="report.reservation_income_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
          </el-form-item>
          <el-form-item label="小程序预约收入金额" label-width="180px" class="income-item">
            <v-input-money class="income-input" v-model="report.reservation_income" :is-show-suffix="true"/>
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="其他收入笔数" label-width="180px" class="income-item">
            <v-input-number v-model="report.other_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
          </el-form-item>
          <el-form-item label="其他收入金额" label-width="180px" class="income-item">
            <v-input-money class="income-input" v-model="report.other_income" :is-show-suffix="true"/>
          </el-form-item>
        </div>

        <el-form-item label="其他收入备注" label-width="180px" class="income-item">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10}"
            v-model="report.other_income_remark"
            class="expenditure-input"
            maxlength="250"
            show-word-limit
          />
        </el-form-item>

        <div class="flex-wrap">
          <el-form-item label="总收入" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.all_income }}</span> 元
          </el-form-item>
        </div>
      </div>

      <div class="table-box">
        <h3>收款方式统计</h3>
        <el-form-item label="门店微信账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.we_chat_income"
            placeholder="请输入门店微信账号金额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="门店支付宝账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.alipay_income"
            placeholder="请输入门店支付宝账号金额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="门店富掌柜账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.fu_zhang_gui_income"
            placeholder="请输入门店富掌柜账号金额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="门店美团账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.meituan_income"
            placeholder="请输入门店美团账号金额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="门店银行账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.card_income"
            placeholder="请输入门店银行账号金额"
            :is-show-suffix="true"
          />
        </el-form-item>

        <el-form-item label="现金" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.cash_income"
            placeholder="请输入现金金额"
            :is-show-suffix="true"
          />
        </el-form-item>

        <el-form-item label="总部有赞账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.you_zan_income"
            placeholder="请输入总部有赞账号金额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="总部抖音账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.dou_yin_income"
            placeholder="请输入总部抖音账号金额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="总部银行账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.transfer_income"
            placeholder="请输入总部银行账号金额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="总部小程序账号" label-width="140px">
          <v-input-money
            class="expenditure-input"
            v-model="report.applet_income"
            placeholder="请输入总部小程序金额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="总收入" label-width="110px">
          <span class="danger-color money">{{ report.all_income_way }}</span> 元
        </el-form-item>
        <el-form-item label="总课消" label-width="110px">
          <span class="danger-color money">{{ report.course_consumption | toYuan }}</span> 元
        </el-form-item>
      </div>

      <div class="table-box">
        <h3>有赞支付统计</h3>

        <el-table
          :data="youZanIncomes"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-student link-page-id="student_id"/>
          <v-column-time value="使用时间" field="register_time" sortable=""/>
          <el-table-column label="有赞码券" align="center" prop="you_zan_number" type="isNotSummary"/>
          <el-table-column label="实际付款" align="center" prop="actual_payment" type="money">
            <template v-slot="{ row }">
              {{ row.actual_payment | toYuan }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <h3>老师工资统计</h3>

        <div class="course-stat-summary">
          <template v-if="report.is_ladder_salary">
            大课共
            <b>{{ courseStatSummary.groupCourseCount }}</b> 小时（成人 {{ courseStatSummary.adultCourseCount }} + 少儿 {{ courseStatSummary.childCourseCount }}<template v-if="report.is_has_major"> + 专业 {{ courseStatSummary.majorCourseCount }}</template>），
          </template>
          <template v-else>
            大课共
            <b>{{ courseStatSummary.groupCourseCount }}</b> 小时，
          </template>
          <template v-if="courseStatSummary.groupCourseCount">
            大课课时总人次 <b>{{ courseStatSummary.totalAttendance }}</b>，
            平均 <b>{{ courseStatSummary.averageAttendance }}</b> 人/小时
            <span class="course-stat-hint">（大课总人次由日总结提供）</span>
          </template>
          <template v-else>
            请先填写各老师的大课课时数，再核对下方带入的大课总人次
          </template>
        </div>

        <el-dialog title="老师工资总计" :visible.sync="isShowCourseDialog" class="teacher-dialog">
          <el-table
            :data="courses"
            border
            fit
            highlight-current-row
            :show-summary="true"
            :summary-method="getTeacherSummaries"
          >
            <el-table-column label="序号" align="center" width="130">
              <template v-slot="{ $index, row }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="课程时间" align="center" width="260" type="isNotSummary">
              <template v-slot="{ row }">{{ row.start_time | timeToYmdHi }}{{ ' - '}}{{ row.end_time | timeToHi }}</template>
            </el-table-column>
            <el-table-column label="课程时长" align="center" width="120" prop="duration" type="money">
              <template v-slot="{ row }">
                {{ row.duration | toYuan }}
              </template>
            </el-table-column>
            <el-table-column label="课程类型" align="center" prop="card_type_name" />
            <el-table-column label="课程名称" align="center" prop="course_name" />
            <el-table-column label="预约人数" align="center" prop="student_count" />
            <el-table-column label="出勤状态" align="center">
              <template v-slot="{ row }">
                <el-tag
                  v-for="v in findCourseState(row.course_state)"
                  :key="`courseStateSub${v.name}`"
                  :type="v.tagType"
                >
                  {{ v.name }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="代课老师" align="center" prop="nickname" type="isNotSummary"/>
            <el-table-column label="课时费" align="center" prop="salary" type="money">
              <template v-slot="{ row }">
                {{ row.salary | toYuan }}
              </template>
            </el-table-column>
            <el-table-column label="绩效" align="center" prop="bonus" type="money">
              <template v-slot="{ row }">
                {{ row.bonus | toYuan }}
              </template>
            </el-table-column>
            <el-table-column label="实发" align="center" prop="actual_payment" type="money">
              <template v-slot="{ row }">
                {{ row.actual_payment | toYuan }}
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>

        <el-dialog
          title="工资条"
          :visible.sync="isShowPayslipDialog"
          width="25%"
          center>
          <div class="course-alert" ref="payslip">
            <template v-if="report.is_ladder_salary">
              <div v-if="adult_course_count" class="course-alert-item">
                成人班上课 {{ adult_course_count }} 小时<template v-if="adult_student_average">，平均人数 {{ adult_student_average }}</template>
              </div>
              <div v-if="adult_bonus" class="course-alert-item">
                奖金 {{ adult_bonus }}（
                <template v-for="(v, k) in adult_bonus_count">
                  {{ v.course_count }} 小时超过 {{ v.min_number }} 人 + {{ v.course_count }} x {{ v.bonus | toYuan }}
                  <template v-if="k !== adult_bonus_count.length - 1">，</template>
                </template>）
              </div>
              <div v-if="child_course_count" class="course-alert-item">
                少儿班上课 {{ child_course_count }} 小时<template v-if="child_student_average">，平均人数 {{ child_student_average }}</template>
              </div>
              <div v-if="child_bonus" class="course-alert-item">
                奖金 {{ child_bonus }}（
                <template v-for="(v, k) in child_bonus_count">
                  {{ v.course_count }} 小时超过 {{ v.min_number }} 人 + {{ v.course_count }} x {{ v.bonus | toYuan }}
                  <template v-if="k !== child_bonus_count.length - 1">，</template>
                </template>）
              </div>
              <div v-if="major_course_count" class="course-alert-item">
                专业班上课 {{ major_course_count }} 小时<template v-if="major_student_average">，平均人数 {{ major_student_average }}</template>
              </div>
              <div v-if="major_bonus" class="course-alert-item">
                奖金 {{ major_bonus }}（
                <template v-for="(v, k) in major_bonus_count">
                  {{ v.course_count }} 小时超过 {{ v.min_number }} 人 + {{ v.course_count }} x {{ v.bonus | toYuan }}
                  <template v-if="k !== major_bonus_count.length - 1">，</template>
                </template>）
              </div>
            </template>
            <template v-else>
              <div v-if="group_course_count" class="course-alert-item">
                大课 {{ group_course_count }} 小时<template v-if="group_student_average > 1">，平均人数 {{ group_student_average }}</template>
              </div>
            </template>

            <div v-if="private_course_count" class="course-alert-item">
              私教上课 {{ private_course_count }} 小时<template v-if="personal_student_average > 1">，平均人数 {{ personal_student_average }}</template>
            </div>
            <div v-if="base_pay" class="course-alert-item">
              底薪 {{ base_pay }}
            </div>
            <div v-if="social_insurance" class="course-alert-item">
              公司社保 {{ social_insurance }}
            </div>
            <div v-if="store_insurance" class="course-alert-item">
              门店社保 {{ store_insurance }}
            </div>
            <div v-if="personal_insurance" class="course-alert-item">
              个人社保 {{ personal_insurance }}
            </div>
            <div v-if="absence_count" class="course-alert-item">
              旷课 {{ absence_count }} 小时
            </div>
            <div class="course-alert-item">
              合计
              <template v-if="report.is_ladder_salary">
                <template v-if="adult_course_count">
                  {{ adult_course_count }} × {{ adult_class_pay }}
                  <template v-if="adult_bonus">+ {{ adult_bonus }} </template>
                </template>
                <template v-if="child_course_count">
                  <template v-if="adult_course_count">+ </template>{{ child_course_count }} × {{ child_class_pay }}
                  <template v-if="child_bonus">+ {{ child_bonus }}</template>
                </template>
                <template v-if="major_course_count">
                  + {{ major_course_count }} × {{ major_class_pay }}
                  <template v-if="major_bonus">+ {{ major_bonus }}</template>
                </template>
              </template>
              <template v-else>
                <template v-if="group_course_count">
                  {{ group_course_count }} × {{ group_class_pay }}
                </template>
              </template>

              <template v-if="private_course_count">
                + {{ private_course_count }} × {{ private_class_pay }}
              </template>
              <template v-if="base_pay">
                + {{ base_pay }}
              </template>
              <template v-if="social_insurance">
                + {{ social_insurance }}
              </template>
              <template v-if="store_insurance">
                + {{ store_insurance }}
              </template>
              <template v-if="absence_count">
                - {{ absence_count }} × {{ leave_class_pay }}
              </template>
              = {{ all_pay }}
            </div>
            <div class="course-alert-item" v-if="actual_pay !== all_pay">
              实发 {{ all_pay }} - {{ social_insurance }} - {{ store_insurance }} - {{ personal_insurance }} = {{ actual_pay }}
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShowPayslipDialog = false">返回</el-button>
            <el-button type="primary" @click="copyPayslip">复制</el-button>
          </span>
        </el-dialog>

        <el-table
          v-if="!isLoading && !isTeacherSalariesLoading"
          :data="teacherSalaries"
          border
          fit
          highlight-current-row
          :show-summary="true"
          :summary-method="getTeacherSummaries"
          class="teacher-salary-table"
          :height="teacherSalaries.length > 7 ? 699 : undefined"
        >
          <el-table-column label="老师" align="center" width="130" fixed="left">
            <template v-slot="{ row }">
              <v-select-teacher v-model="row.teacher_id" :list="teachers" :remote="true" :clearable="true"/>
            </template>
          </el-table-column>
          <el-table-column v-if="!report.is_ladder_salary" label="大课" width="210" align="center" prop="group_course_pay">
            <template v-slot="{ row }">
              <div class="flex-align-center">
                <v-input-money
                  v-model="row.group_course_count"
                  class="course-count-input"
                  @input="computeGroupCoursePay(row, { group_course_count: $event })"
                />
                <span class="separator">×</span>
                <v-input-money
                  v-model="row.class_pay"
                  class="course-money-input"
                  @input="computeGroupCoursePay(row, { class_pay: $event })"
                />
                <span class="separator">=</span>
                <b>{{ row.group_course_pay }}</b>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-if="report.is_ladder_salary" label="成人班" width="210" align="center" prop="adult_course_pay">
            <template v-slot="{ row }">
              <div class="flex-align-center">
                <v-input-money
                  class="course-count-input"
                  v-model="row.adult_course_count"
                  @input="computeAdultCoursePay(row, { adult_course_count: $event })"
                />
                <span class="separator">×</span>
                <v-input-money
                  v-model="row.adult_class_pay"
                  class="course-money-input"
                  @input="computeAdultCoursePay(row, { adult_class_pay: $event })"
                />
                <span class="separator">=</span>
                <b>{{ row.adult_course_pay }}</b>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-if="report.is_ladder_salary" label="少儿班" width="210" align="center" prop="child_course_pay">
            <template v-slot="{ row }">
              <div class="flex-align-center">
                <v-input-money
                  class="course-count-input"
                  v-model="row.child_course_count"
                  @input="computeChildCoursePay(row, { child_course_count: $event })"
                />
                <span class="separator">×</span>
                <v-input-money
                  v-model="row.child_class_pay"
                  class="course-money-input"
                  @input="computeChildCoursePay(row, { child_class_pay: $event })"
                />
                <span class="separator">=</span>
                <b>{{ row.child_course_pay }}</b>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-if="report.is_ladder_salary && report.is_has_major" label="专业班" width="210" align="center" prop="major_course_pay">
            <template v-slot="{ row }">
              <div class="flex-align-center">
                <v-input-money
                  class="course-count-input"
                  v-model="row.major_course_count"
                  @input="computeMajorCoursePay(row, { major_course_count: $event })"
                />
                <span class="separator">×</span>
                <v-input-money
                  v-model="row.major_class_pay"
                  class="course-money-input"
                  @input="computeMajorCoursePay(row, { major_class_pay: $event })"
                />
                <span class="separator">=</span>
                <b>{{ row.major_course_pay }}</b>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="私教" align="center" width="210" prop="private_course_pay">
            <template v-slot="{ row }">
              <div class="flex-align-center">
                <v-input-money
                  class="course-count-input"
                  v-model="row.private_course_count"
                  @input="computePrivateCoursePay(row, { private_course_count: $event })"
                />
                <span class="separator">×</span>
                <v-input-money
                  v-model="row.private_class_pay"
                  class="course-money-input"
                  @input="computePrivateCoursePay(row, { private_class_pay: $event })"
                />
                <span class="separator">=</span>
                <b>{{ row.private_course_pay }}</b>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="旷课" align="center" width="210" prop="absence_pay">
            <template v-slot="{ row }">
              <div class="flex-align-center">
                <v-input-money
                  class="course-count-input"
                  v-model="row.absence_count"
                  @input="computeAbsencePay(row, { absence_count: $event })"
                />
                <span class="separator">×</span>
                <v-input-money
                  v-model="row.leave_class_pay"
                  class="course-money-input"
                  @input="computeAbsencePay(row, { leave_class_pay: $event })"
                />
                <span class="separator">=</span>
                <b>{{ row.absence_pay }}</b>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="底薪" align="center" width="90" prop="base_pay">
            <template v-slot="{ row }">
              <v-input-money
                v-model="row.base_pay"
                class="teacher-salary-input"
                @input="computeTeacherPayments(row, { base_pay: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column label="公司社保" align="center" width="90" prop="social_insurance">
            <template v-slot="{ row }">
              <v-input-money
                v-model="row.social_insurance"
                class="teacher-salary-input"
                @input="computeTeacherPayments(row, { social_insurance: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column label="门店社保" align="center" width="90" prop="store_insurance">
            <template v-slot="{ row }">
              <v-input-money
                v-model="row.store_insurance"
                class="teacher-salary-input"
                @input="computeTeacherPayments(row, { store_insurance: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column label="个人社保" align="center" width="90" prop="personal_insurance">
            <template v-slot="{ row }">
              <v-input-money
                v-model="row.personal_insurance"
                class="teacher-salary-input"
                @input="computeTeacherPayments(row, { personal_insurance: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column v-if="report.is_ladder_salary" label="绩效" align="center" width="90" prop="bonus">
            <template v-slot="{ row }">
              <v-input-money
                v-model="row.bonus"
                class="teacher-salary-input"
                @input="computeTeacherPayments(row, { bonus: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column label="实发" align="center" width="90" prop="actual_pay">
            <template v-slot="{ row }">
              {{ row.actual_pay }}
            </template>
          </el-table-column>
          <el-table-column label="合计" align="center" width="90" prop="all_pay">
            <template v-slot="{ row }">
              <span class="success-color">{{ row.all_pay }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template v-slot="{ $index, row }">

              <el-button class="table-button" size="mini" type="primary" :loading="isCourseLoading" @click="getTeacherCourses(row)">详情</el-button>

              <el-button class="table-button" size="mini" type="success" :loading="isCourseLoading" @click="showPayslip(row)">工资条</el-button>

              <el-button size="mini" type="danger" @click="handleDeleteTeacher($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button class="add-button" type="primary" @click="addTeacherSalaries">新增一项</el-button>
      </div>

      <div class="table-box">
        <h3>店员工资统计</h3>
        <div v-if="manualStaffRowCount" class="staff-manual-tip">
          <i class="el-icon-warning-outline"/>
          有 {{ manualStaffRowCount }} 行手动改过实发底薪/提成（带黄点），修改收入后不会自动变化；需要更新时点该行【重新计算】。
        </div>
        <el-table
          :data="staffSalaries"
          border
          fit
          highlight-current-row
          :show-summary="true"
          :summary-method="getStaffSummaries"
          :height="staffSalaries.length > 7 ? 699 : undefined"
        >
          <el-table-column label="员工" align="center" width="154">
            <template v-slot="{ row }">
              <v-select-administrator
                :store-id="report.store_id"
                v-model="row.administrator_id"
                placeholder="请选择员工"
                @change="(id) => getStaffSalary(id, row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="底薪" align="center" prop="base_pay" width="130">
            <template v-slot="{ row }">
              <v-input-money
                class="staff-salary-input"
                v-model="row.base_pay"
                @input="handleBasePayChange($event, row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="业绩任务" align="center" width="130">
            <template v-slot="{ row }">
              <v-input-money
                class="staff-salary-input"
                v-model="row.task_income"
                @input="handleTaskIncomeChange($event, row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="未完成底薪比例" align="center" width="140">
            <template v-slot="{ row }">
              <v-input-money
                class="staff-salary-input"
                v-model="row.base_pay_rate"
                :min="0"
                :max="100"
                @input="handleBasePayRateChange($event, row)"
              />
              %
            </template>
          </el-table-column>

          <el-table-column label="完成后提成比例" align="center" width="140">
            <template v-slot="{ row }">
              <v-input-money
                class="staff-salary-input"
                v-model="row.commission_rate"
                :min="0"
                :max="100"
                @input="handleCommissionRateChange($event, row)"
              />
              %
            </template>
          </el-table-column>

          <el-table-column label="实发底薪" align="center" prop="actual_base_pay" width="130">
            <template v-slot="{ row }">
              <el-tooltip :disabled="!row.is_manual_actual_base_pay" :content="manualSalaryTip('actual_base_pay', row)" placement="top">
                <div class="manual-salary-cell" :class="{ 'is-manual': row.is_manual_actual_base_pay }">
                  <v-input-money
                    class="staff-salary-input"
                    v-model="row.actual_base_pay"
                    @input="computeStaffPayments(row, { actual_base_pay: $event })"
                    @change="markActualBasePayManual($event, row)"
                  />
                  <span v-if="row.is_manual_actual_base_pay" class="manual-dot"></span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="提成" align="center" prop="percentage_pay" width="130">
            <template v-slot="{ row }">
              <el-tooltip :disabled="!row.is_manual_commission" :content="manualSalaryTip('commission', row)" placement="top">
                <div class="manual-salary-cell" :class="{ 'is-manual': row.is_manual_commission }">
                  <v-input-money
                    class="staff-salary-input"
                    v-model="row.commission"
                    @input="computeStaffPayments(row, { commission: $event })"
                    @change="markCommissionManual($event, row)"
                  />
                  <span v-if="row.is_manual_commission" class="manual-dot"></span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="公司社保" align="center" prop="social_insurance" width="130">
            <template v-slot="{ row }">
              <v-input-money
                class="staff-salary-input"
                v-model="row.social_insurance"
                @input="computeStaffPayments(row, { social_insurance: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column label="门店社保" align="center" prop="store_insurance" width="130">
            <template v-slot="{ row }">
              <v-input-money
                class="staff-salary-input"
                v-model="row.store_insurance"
                @input="computeStaffPayments(row, { store_insurance: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column label="个人社保" align="center" prop="personal_insurance" width="130">
            <template v-slot="{ row }">
              <v-input-money
                class="staff-salary-input"
                v-model="row.personal_insurance"
                @input="computeStaffPayments(row, { personal_insurance: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column label="奖金" align="center" prop="bonus" width="130">
            <template v-slot="{ row }">
              <v-input-money
                class="staff-salary-input"
                v-model="row.bonus"
                @input="computeStaffPayments(row, { bonus: $event })"
              />
            </template>
          </el-table-column>
          <el-table-column label="实发" align="center" prop="actual_pay">
            <template v-slot="{ row }">
              {{ row.actual_pay }}
            </template>
          </el-table-column>
          <el-table-column label="总计" align="center" prop="all_pay">
            <template v-slot="{ row }">
              <span class="success-color">{{ row.all_pay }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="190"
            class-name="small-padding fixed-width"
          >
            <template v-slot="{ $index, row }">
              <el-tooltip :content="row.is_manual_actual_base_pay || row.is_manual_commission ? '按最新数据重新计算本行，手动改过的金额会被覆盖' : '按最新的收入、底薪和业绩任务，重新计算本行的实发底薪和提成'" placement="top">
                <el-button class="edit-button" size="mini" :type="row.is_manual_actual_base_pay || row.is_manual_commission ? 'warning' : 'primary'" @click="recalcStaffRow(row)">重新计算</el-button>
              </el-tooltip>
              <el-button class="edit-button" size="mini" type="danger" @click="handleDeleteStaff($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          class="income-table add-button"
          type="info"
          show-icon
          :closable="false"
        >
          <div class="performance-summary-item">
            本月业绩收入：新生 {{ staffPerformanceSummary.new_income }} 元 + 老生 {{ staffPerformanceSummary.old_income }} 元 + 小程序预约(不含退款) {{ staffPerformanceSummary.reservationIncome }} 元 + 课次券 {{ staffPerformanceSummary.cardTicketIncome }} 元 + 代金券 {{ staffPerformanceSummary.voucherIncome }} 元 = 合计 <b>{{ staffPerformanceSummary.totalIncome }}</b> 元
          </div>
          <div
            v-for="item in staffPerformanceSummary.items"
            :key="item.name"
            class="performance-summary-item"
            :class="item.isMet ? 'success-color' : 'danger-color'"
          >
            {{ item.name }}：完成 {{ item.percentage }}%（{{ item.isMet ? `超出 ${item.diff}` : `差 ${-item.diff}` }} 元）{{ item.isMet ? '已完成' : '未达标' }}，提成：{{ item.isMet && item.commissionRate ? `${item.diff} × ${item.commissionRate}% = ${item.commission}` : '0 元' }}
          </div>
        </el-alert>
        <el-button class="add-button" type="primary" @click="addStaffSalaries">新增一项</el-button>
      </div>

      <div class="table-box">
        <h3>支出统计</h3>
        <el-form-item label="老师工资">
          <v-input-money
            class="expenditure-input"
            v-model="report.teacher_pay"
            placeholder="请输入老师工资"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="店员工资">
          <v-input-money
            class="expenditure-input"
            v-model="report.staff_pay"
            placeholder="请输入店员工资"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="保洁工资">
          <v-input-money
            class="expenditure-input"
            v-model="report.cleaner_pay"
            placeholder="请输入保洁工资"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="房租费用">
          <v-input-money
            class="expenditure-input"
            v-model="report.house_pay"
            placeholder="请输入房租费用"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="广告费用">
          <v-input-money
            class="expenditure-input"
            v-model="report.advert_pay"
            placeholder="请输入广告费用"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="订购饮料费用">
          <v-input-money
            class="expenditure-input"
            v-model="report.drink_pay"
            placeholder="请输入订购饮料费用"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="水电宽带电话费用">
          <v-input-money
            class="expenditure-input"
            v-model="report.water_pay"
            placeholder="请输入水电宽带电话费用"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="发票税额">
          <v-input-money
            class="expenditure-input"
            v-model="report.tax_amount_pay"
            placeholder="请输入发票税额"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="退卡支出">
          <v-input-money
            class="expenditure-input"
            v-model="report.refund_pay"
            placeholder="请输入退卡支出"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="券退款支出（需转总部）">
          <v-input-money
            class="expenditure-input"
            v-model="report.ticket_refund_pay"
            placeholder="请输入券退款支出"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="券退款笔数">
          <v-input-number v-model="report.ticket_refund_count" class="number-item" :is-show-suffix="true" suffix-name="笔"/>
        </el-form-item>
        <el-form-item label="修改课卡补差价支出">
          <v-input-money
            class="expenditure-input"
            v-model="report.update_pay"
            placeholder="请输入修改课卡补差价支出"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="小程序预约退款支出">
          <v-input-money
            class="expenditure-input"
            v-model="report.reservation_pay"
            placeholder="请输入小程序预约退款支出"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="其他支出">
          <v-input-money
            class="expenditure-input"
            v-model="report.other_pay"
            placeholder="请输入其他支出"
            :is-show-suffix="true"
          />
        </el-form-item>
        <el-form-item label="其他支出备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10}"
            v-model="report.other_pay_remark"
            class="expenditure-input"
            maxlength="250"
            show-word-limit
          />
        </el-form-item>
      </div>

      <div class="table-box">
        <div class="profit-box">
          <h3 class="profit-title">总收入</h3>
          <h2 class="danger-color">{{ report.all_income }}</h2>
        </div>
        <div class="profit-box">
          <h3 class="profit-title">总支出</h3>
          <h2 class="success-color">{{ report.expenditure }}</h2>
        </div>
        <div class="profit-box">
          <h3 class="profit-title">总利润</h3>
          <h2 :class="`${report.profit >= 0 ? 'danger' : 'success'}-color`">
            {{ computeProfit(report) }}
          </h2>
        </div>

        <template v-if="report.store_revenue_sharing || report.revenue_sharing">
          <div class="profit-box">
            <h3 class="profit-title">总部提成百分比</h3>
            <h2 v-if="report.is_generic" class="success-color">{{ report.revenue_sharing }} %</h2>
            <v-input-money
              v-else
              v-model="report.revenue_sharing"
              :is-show-suffix="true"
              suffix-name="%"
              class="expenditure-input"
            />
          </div>
          <div class="profit-box">
            <h3 class="profit-title">总部提成</h3>
            <v-input-money
              class="expenditure-input"
              v-model="report.commission"
              placeholder="请输入总部提成金额"
              :is-show-suffix="true"
            />
          </div>
          <el-alert
            v-if="+report.defaultCommission !== +report.commission"
            :title="`当前提成数额与系统计算数额「${report.defaultCommission}」不相符，请确认无误后提交！`"
            class="commission-tip"
            type="info"
            effect="dark"
            show-icon
            :closable="false"
          />
          <div class="profit-box">
            <h3 class="profit-title">最终盈利</h3>
            <h2 :class="`${report.net_profit >= 0 ? 'danger' : 'success'}-color`">{{ report.net_profit }}</h2>
          </div>
        </template>
      </div>

      <el-button v-if="report.is_draft" type="success" @click="handleSubmit(0)" :loading="isSaving">立即发布</el-button>
      <el-button type="primary" @click="handleSubmit(report.is_draft)" :loading="isSaving">保存修改</el-button>
      <el-button @click="RouteConfig.monthlyReportList.back">返回</el-button>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { findCourseState } from '@/enums/courseStates';
import copyToClipboard from '@/utils/clipboard';
import { getSummaries } from '@/utils/getSummary';
import { formatYuan } from '@/filters';
import {
  plus,
  minus,
  multipliedBy,
  dividedBy,
  decimalPlaces,
  toYuan,
  toCent,
  toSecond,
  toMillisecond,
  getTableSummaries,
} from '@/utils/number';
import { index as getTeachers } from '@/api/teacher';
import {
  show,
  getAttendance,
  getStaffSalariesByReportId,
  getTeacherSalariesByReportId,
  update,
  getCards,
  getTeacherCourses,
  getInvoices,
} from '@/api/monthly-report';
import { getReservationIncomes, getReservationPays, getUpdatePayments } from '@/api/daily-report';
import { getSalaryByAdministratorId } from '@/api/administrator';
import { findPaymentModeName } from "@/enums/paymentModes";

export default {
  name: RouteConfig.monthlyReportEdit.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isCardsLoading: false,
    // 「详情」与「工资条」都会拉老师排课，共用一个 loading 防止连点重复请求
    isCourseLoading: false,
    isShowCourseDialog: false,
    isShowPayslipDialog: false,
    isLoadingError: false,

    isTeacherSalariesLoading: false,
    isSaving: false,

    // 新增：标记页面初始化是否完成，避免初始化过程中自动重算覆盖接口数据
    isInitialLoad: true,

    isShowNewCards: false,
    isShowOldCards: false,
    isShowDelCards: false,
    isShowOtherIncomes: false,
    isShowUpdateIncomes: false,
    isShowReservationIncomes: false,
    isShowUpdatePays: false,
    isShowReservationPays: false,
    isShowInvoices: false,

    cardListPageSize: 8,
    courseCount: 0,
    stores: [],
    teacherSalaries: [],
    staffSalaries: [],
    youZanIncomes: [],
    teachers: [],
    newCards: [],
    oldCards: [],
    delCards: [],
    invoices: [],
    otherIncomes: [],
    updateIncomes: [],
    reservationIncomes: [],
    reservationPays: [],
    updatePays: [],
    courses: [],

    social_insurance: 0,
    store_insurance: 0,
    personal_insurance: 0,

    adult_bonus: 0,
    child_bonus: 0,
    major_bonus: 0,

    group_course_count: 0,
    adult_course_count: 0,
    child_course_count: 0,
    major_course_count: 0,
    private_course_count: 0,
    absence_count: 0,
    new_cards_del_count: 0,
    old_cards_del_count: 0,
    reservation_income_del_count: 0,

    base_pay: 0,
    all_pay: 0,
    actual_pay: 0,
    group_class_pay: 0,
    adult_class_pay: 0,
    child_class_pay: 0,
    major_class_pay: 0,
    private_class_pay: 0,
    leave_class_pay: 0,

    adult_bonus_count: [],
    child_bonus_count: [],
    major_bonus_count: [],

    adult_course_leave_count: 0,
    child_course_leave_count: 0,
    major_course_leave_count: 0,
    personal_course_leave_count: 0,

    group_student_average: 0,
    adult_student_average: 0,
    child_student_average: 0,
    major_student_average: 0,
    personal_student_average: 0,

    pickerOptions: {
      disabledDate: (time) => time.getTime() >= Date.now(),
    },
    report: {
      add_time: '',
      store_id: '',
      report_date: '',

      new_income: 0,
      old_income: 0,
      trial_income: 0,
      card_ticket_income: 0,
      voucher_income: 0,
      update_income: 0,
      reservation_income: 0,
      reservation_income_valid: 0,
      other_income: 0,
      other_income_remark: '',

      we_chat_income: 0,
      alipay_income: 0,
      fu_zhang_gui_income: 0,
      meituan_income: 0,
      card_income: 0,
      cash_income: 0,
      you_zan_income: 0,
      dou_yin_income: 0,
      transfer_income: 0,
      applet_income: 0,

      all_income: 0,
      all_income_way: 0,
      task_income: 0,
      new_count: 0,
      old_count: 0,
      trial_count: 0,
      card_ticket_income_count: 0,
      voucher_income_count: 0,
      ticket_refund_pay: 0,
      ticket_refund_count: 0,
      refund_count: 0,
      update_income_count: 0,
      reservation_income_count: 0,
      update_pay_count: 0,
      reservation_pay_count: 0,
      invoice_count: 0,
      other_count: 0,
      total_attendance: 0,
      average_attendance: 0,
      course_consumption: 0,

      teacher_pay: 0,
      staff_pay: 0,
      house_pay: 0,
      advert_pay: 0,
      cleaner_pay: 0,
      drink_pay: 0,
      water_pay: 0,
      tax_amount_pay: 0,
      refund_pay: 0,
      update_pay: 0,
      reservation_pay: 0,
      other_pay: 0,
      other_pay_remark: '',
      expenditure: 0,

      profit: 0,
      revenue_sharing: 0,
      commission: 0,
      net_profit: 0,

      is_ladder_salary: 0,
      is_has_major: 0,
      store_revenue_sharing: 0,
      is_draft: 0,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
    incomeData() {
      const { new_income, old_income, trial_income, card_ticket_income, voucher_income, other_income, update_income, reservation_income } = this.report;
      return { new_income, old_income, trial_income, card_ticket_income, voucher_income, other_income, update_income, reservation_income };
    },
    incomeWayData() {
      const {
        we_chat_income,
        alipay_income,
        fu_zhang_gui_income,
        meituan_income,
        card_income,
        cash_income,
        you_zan_income,
        dou_yin_income,
        transfer_income,
        applet_income,
      } = this.report;
      return {
        we_chat_income,
        alipay_income,
        fu_zhang_gui_income,
        meituan_income,
        card_income,
        cash_income,
        you_zan_income,
        dou_yin_income,
        transfer_income,
        applet_income,
      };
    },
    // 店员工资表格下方的业绩完成度汇总
    staffPerformanceSummary() {
      const { new_income, old_income, reservation_income_valid, card_ticket_income, voucher_income } = this.report;
      const reservationIncome = reservation_income_valid || 0;
      const cardTicketIncome = card_ticket_income || 0;
      const voucherIncome = voucher_income || 0;
      const totalIncome = plus(new_income, old_income, reservationIncome, cardTicketIncome, voucherIncome);
      const items = this.staffSalaries
        .filter(v => v.task_income)
        .map(v => {
          const taskIncome = v.task_income;
          const percentage = decimalPlaces(multipliedBy(dividedBy(totalIncome, taskIncome), 100), 1);
          const diff = decimalPlaces(minus(totalIncome, taskIncome));
          const commissionRate = v.commission_rate || 0;
          const commission = diff > 0 && commissionRate
            ? decimalPlaces(multipliedBy(diff, toYuan(commissionRate)))
            : 0;
          return {
            name: v.nickname || v.administrator_id,
            percentage,
            diff,
            isMet: totalIncome >= taskIncome,
            commissionRate,
            commission,
          };
        });

      return { new_income, old_income, reservationIncome, cardTicketIncome, voucherIncome, totalIncome, items };
    },
    // 有手动调整实发底薪/提成的行数，用于页面提示
    manualStaffRowCount() {
      return this.staffSalaries.filter(v => v.is_manual_actual_base_pay || v.is_manual_commission).length;
    },
    // 大课课程统计摘要：总课时（真实小时）、总人次、平均人数（人/节）
    courseStatSummary() {
      let groupCourseCount = 0;
      let adultCourseCount = 0;
      let childCourseCount = 0;
      let majorCourseCount = 0;
      this.teacherSalaries.forEach(v => {
        groupCourseCount += +v.group_course_count || 0;
        adultCourseCount += +v.adult_course_count || 0;
        childCourseCount += +v.child_course_count || 0;
        majorCourseCount += +v.major_course_count || 0;
      });
      if (this.report.is_ladder_salary) {
        groupCourseCount = adultCourseCount + childCourseCount + majorCourseCount;
      }
      // total_attendance 存储值为实际值×100，先转真实人次再计算平均
      const totalAttendance = toYuan(+this.report.total_attendance || 0);
      const averageAttendance = groupCourseCount
        ? decimalPlaces(dividedBy(totalAttendance, groupCourseCount))
        : 0;
      return { groupCourseCount, adultCourseCount, childCourseCount, majorCourseCount, totalAttendance, averageAttendance };
    },
    expenditureData() {
      const { teacher_pay, staff_pay, cleaner_pay, house_pay, advert_pay, drink_pay, water_pay,  tax_amount_pay, refund_pay, ticket_refund_pay, other_pay, update_pay, reservation_pay } = this.report;
      return { teacher_pay, staff_pay, cleaner_pay, house_pay, advert_pay, drink_pay, water_pay,  tax_amount_pay, refund_pay, ticket_refund_pay, other_pay, update_pay, reservation_pay };
    },
  },
  watch: {
    'report.report_date'() {
      this.handleReportDateAndStoreIdChange();
    },
    'report.store_id'() {
      this.handleReportDateAndStoreIdChange();
    },
    incomeData() {
      this.computeAllIncome();
      // 仅在初始化完成后才自动重算店员工资，防止覆盖接口返回的真实数据
      if (!this.isInitialLoad) {
        this.computeAllStaffActualBasePay();
      }
    },
    incomeWayData() {
      this.computeAllIncomeForIncomeWay();
    },
    expenditureData(report) {
      this.computeExpenditure(report);
    },

    'report.profit'() {
      this.computeCommission();
    },
    'report.revenue_sharing'() {
      this.computeCommission();
    },
    'report.commission'() {
      this.computeNetProfit();
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    getTableSummaries,
    findCourseState,
    findPaymentModeName,
    tableRowClassName({ row }) {
      return row.is_del ? 'warning-background' : '';
    },
    reservationIncomeTableRowClassName({ row }) {
      return row.is_refund ? 'warning-background' : '';
    },
    async load() {
      if (this.isLoading) return;

      this.isLoading = true;
      this.isLoadingError = false;
      // 标记为初始化阶段，阻断自动重算
      this.isInitialLoad = true;

      await Promise.all([
        this.show(),
        this.getTeacherSalaries(),
        this.getStaffSalaries(),
      ]);

      this.isLoading = false;
      // 用“保存值 vs 当前公式值”还原每个格子的手工/自动状态：相等的继续自动跟随，不等的作为手工值保留
      this.initStaffManualFlags();
      // 初始化完成，允许后续变更触发自动计算
      this.isInitialLoad = false;
    },
    async handleReportDateAndStoreIdChange() {
      if (this.isCardsLoading) return;
      if (!this.report.store_id) return;

      this.isCardsLoading = true;
      this.isLoadingError = false;

      await this.getTeachers();

      this.isCardsLoading = false;
    },
    computeGroupCoursePay(row, newData) {
      const { group_course_count, class_pay } = Object.assign(row, newData);
      row.group_course_pay = multipliedBy(group_course_count, class_pay);
      this.computeTeacherPayments(row, { group_course_pay: row.group_course_pay })
    },
    computePrivateCoursePay(row, newData) {
      const { private_course_count, private_class_pay } = Object.assign(row, newData);
      row.private_course_pay = multipliedBy(private_course_count, private_class_pay);
      this.computeTeacherPayments(row, { private_course_pay: row.private_course_pay })
    },
    computeAbsencePay(row, newData) {
      const { absence_count, leave_class_pay } = Object.assign(row, newData);
      row.absence_pay = multipliedBy(absence_count, leave_class_pay);
      this.computeTeacherPayments(row, { absence_pay: row.absence_pay });
    },
    computeAdultCoursePay(row, newData) {
      const { adult_course_count, adult_class_pay } = Object.assign(row, newData);
      row.adult_course_pay = multipliedBy(adult_course_count, adult_class_pay);
      this.computeTeacherPayments(row, { adult_course_pay: row.adult_course_pay });
    },
    computeChildCoursePay(row, newData) {
      const { child_course_count, child_class_pay } = Object.assign(row, newData);
      row.child_course_pay = multipliedBy(child_course_count, child_class_pay);
      this.computeTeacherPayments(row, { child_course_pay: row.child_course_pay });
    },
    computeMajorCoursePay(row, newData) {
      const { major_course_count, major_class_pay } = Object.assign(row, newData);
      row.major_course_pay = multipliedBy(major_course_count, major_class_pay);
      this.computeTeacherPayments(row, { major_course_pay: row.major_course_pay });
    },
    getTeacherSummaries(param) {
      return getSummaries({
        param,
        report: this.report,
        allPayField: 'teacher_pay',
      });
    },
    getStaffSummaries(param) {
      return getSummaries({
        param,
        report: this.report,
        allPayField: 'staff_pay',
      });
    },
    computeTeacherPay() {
      let teacherPay = 0;
      this.teacherSalaries.forEach(v => teacherPay = plus(teacherPay, v.all_pay));
      this.report.teacher_pay = teacherPay;
    },
    computeStaffPay() {
      let staffPay = 0;
      this.staffSalaries.forEach(v => staffPay = plus(staffPay, v.all_pay));
      this.report.staff_pay = staffPay;
    },
    handleDeleteTeacher(index) {
      this.$confirm('确认要删除吗？', '提示', { type: 'warning' }).then(() => {
        this.teacherSalaries.splice(index, 1);
      }).catch(() => {});
    },
    handleDeleteStaff(index) {
      this.$confirm('确认要删除吗？', '提示', { type: 'warning' }).then(() => {
        this.staffSalaries.splice(index, 1);
      }).catch(() => {});
    },

    computeTeacherPayments(row, newData) {
      const {
        group_course_pay,
        private_course_pay,
        absence_pay,
        base_pay,
        social_insurance,
        store_insurance,
        personal_insurance,
        adult_course_pay,
        child_course_pay,
        major_course_pay,
        bonus,
      } = Object.assign(row, newData);

      let actualPay = 0;
      let allPay = 0;
      if (this.report.is_ladder_salary) {
        actualPay = plus(adult_course_pay, child_course_pay, major_course_pay, private_course_pay, base_pay, bonus);
        allPay = plus(adult_course_pay, child_course_pay, major_course_pay, private_course_pay, base_pay, bonus, social_insurance, store_insurance);
      } else {
        actualPay = plus(group_course_pay, private_course_pay, base_pay);
        allPay = plus(group_course_pay, private_course_pay, base_pay, social_insurance, store_insurance);
      }

      row.actual_pay = minus(actualPay, absence_pay, personal_insurance);
      row.all_pay = minus(allPay, absence_pay);

      this.computeTeacherPay();
    },

    // 店员工资计算
    // 业绩收入（用于店员实发底薪/提成自动计算）
    getStaffPerformanceIncome() {
      const { new_income, old_income, reservation_income_valid, card_ticket_income, voucher_income } = this.report;
      return plus(new_income, old_income, reservation_income_valid, card_ticket_income, voucher_income);
    },
    // 自动实发底薪：业绩达标发全额底薪，未达标按未完成底薪比例打折
    getAutoActualBasePay(row) {
      if (this.getStaffPerformanceIncome() >= plus(row.task_income, 0)) return plus(row.base_pay, 0);
      return decimalPlaces(multipliedBy(row.base_pay, toYuan(row.base_pay_rate)));
    },
    // 自动提成：(业绩收入 - 业绩任务) × 完成后提成比例，未超过任务为 0
    getAutoCommission(row) {
      const exceedIncome = minus(this.getStaffPerformanceIncome(), row.task_income);
      if (exceedIncome <= 0) return 0;
      return decimalPlaces(multipliedBy(exceedIncome, toYuan(row.commission_rate)));
    },
    isSameMoney(a, b) {
      return Math.abs((+a || 0) - (+b || 0)) < 0.005;
    },
    // 手动格子的悬停提示：直接告诉运营“按当前数据自动算应该是多少”，方便判断要不要重新计算
    manualSalaryTip(field, row) {
      const autoValue = field === 'actual_base_pay' ? this.getAutoActualBasePay(row) : this.getAutoCommission(row);
      return `按当前数据自动计算为 ${formatYuan(autoValue)} 元；当前是手动金额，修改收入后不会自动变化。`;
    },
    handleTaskIncomeChange(task_income, row) {
      this.computeStaffCommission(row);
      this.computeStaffActualBasePay(row);
      this.computeStaffPayments(row, {});
    },
    handleBasePayChange(base_pay, row) {
      this.computeStaffActualBasePay(row);
      this.computeStaffPayments(row, {});
    },
    handleBasePayRateChange(base_pay_rate, row) {
      this.computeStaffActualBasePay(row);
      this.computeStaffPayments(row, {});
    },
    handleCommissionRateChange(commission_rate, row) {
      this.computeStaffCommission(row);
      this.computeStaffPayments(row, {});
    },
    // 手工填写实发底薪/提成时打标：之后底薪、业绩任务、比例或收入变化触发的自动计算不再覆盖。
    // 用 change（值真正变过才触发）而不是 input（失焦也会补发），避免只是点进点出就被当成手工值；
    // 输入值恰好等于自动值不算手工，清空格子则恢复自动
    markActualBasePayManual(actual_base_pay, row) {
      if (actual_base_pay === '' || actual_base_pay === null || actual_base_pay === undefined) {
        row.is_manual_actual_base_pay = false;
        row.actual_base_pay = this.getAutoActualBasePay(row);
        this.computeStaffPayments(row, {});
        return;
      }
      row.is_manual_actual_base_pay = !this.isSameMoney(actual_base_pay, this.getAutoActualBasePay(row));
    },
    markCommissionManual(commission, row) {
      if (commission === '' || commission === null || commission === undefined) {
        row.is_manual_commission = false;
        row.commission = this.getAutoCommission(row);
        this.computeStaffPayments(row, {});
        return;
      }
      row.is_manual_commission = !this.isSameMoney(commission, this.getAutoCommission(row));
    },
    // 修改页加载后，按“保存值是否等于当前公式值”还原每格的手工/自动状态：
    // 相等=自动（后续收入/任务变化会跟随），不等=手工（保留，不被自动覆盖）
    initStaffManualFlags() {
      this.staffSalaries.forEach(row => {
        row.is_manual_actual_base_pay = !this.isSameMoney(row.actual_base_pay, this.getAutoActualBasePay(row));
        row.is_manual_commission = !this.isSameMoney(row.commission, this.getAutoCommission(row));
      });
    },
    // 单行重算：按当前数据重算本行实发底薪/提成；有手工值先确认，重算后恢复自动
    recalcStaffRow(row) {
      const doRecalc = () => {
        row.actual_base_pay = this.getAutoActualBasePay(row);
        row.commission = this.getAutoCommission(row);
        row.is_manual_actual_base_pay = false;
        row.is_manual_commission = false;
        this.computeStaffPayments(row, {});
        this.$message.success('本行工资已按最新数据更新');
      };
      if (!row.is_manual_actual_base_pay && !row.is_manual_commission) return doRecalc();
      this.$confirm('本行的实发底薪或提成有手动调整，重新计算会按最新数据覆盖，是否继续？', '重新计算本行工资', {
        type: 'warning',
        confirmButtonText: '继续重新计算',
        cancelButtonText: '取消',
      }).then(doRecalc).catch(() => {});
    },
    computeAllStaffActualBasePay() {
      this.staffSalaries.forEach(v => {
        this.computeStaffActualBasePay(v);
        this.computeStaffCommission(v);
        // 重算后同步实发/总计，避免只更新两项、总计还是旧值
        this.computeStaffPayments(v, {});
      });
    },
    computeStaffActualBasePay(row) {
      // 运营手工改过的实发底薪保留原值，不被自动计算覆盖
      if (row.is_manual_actual_base_pay) return;
      row.actual_base_pay = this.getAutoActualBasePay(row);
    },
    computeStaffCommission(row) {
      // 运营手工改过的提成保留原值，不被自动计算覆盖
      if (row.is_manual_commission) return;
      row.commission = this.getAutoCommission(row);
    },
    computeStaffPayments(row, newData) {
      const { actual_base_pay, commission, bonus, social_insurance, store_insurance, personal_insurance } = Object.assign(row, newData);

      let basePay = plus(actual_base_pay, commission, bonus);
      row.actual_pay = minus(basePay, personal_insurance);
      row.all_pay = plus(basePay, social_insurance, store_insurance);
      this.computeStaffPay();
    },

    // 总收入计算
    computeAllIncome() {
      const { new_income, old_income, trial_income, card_ticket_income, voucher_income, other_income, update_income, reservation_income } = this.report;
      this.report.all_income = plus(new_income, old_income, trial_income, card_ticket_income, voucher_income, other_income, update_income, reservation_income);
    },
    computeAllIncomeForIncomeWay() {
      const {
        we_chat_income,
        alipay_income,
        fu_zhang_gui_income,
        meituan_income,
        card_income,
        cash_income,
        you_zan_income,
        dou_yin_income,
        transfer_income,
        applet_income,
      } = this.report;
      this.report.all_income_way = plus(
        we_chat_income,
        alipay_income,
        fu_zhang_gui_income,
        meituan_income,
        card_income,
        cash_income,
        you_zan_income,
        dou_yin_income,
        transfer_income,
        applet_income,
      );
    },
    checkAllIncome() {
      return this.report.all_income === this.report.all_income_way
        ? ''
        : '新生、老生、试课、课次券、代金券、修改课卡补差价、小程序预约、其他收入总和应等于所有支付方式收入的总和';
    },

    computeExpenditure({
                         teacher_pay,
                         staff_pay,
                         house_pay,
                         advert_pay,
                         cleaner_pay,
                         drink_pay,
                         water_pay,
                         tax_amount_pay,
                         refund_pay,
                         ticket_refund_pay,
                         other_pay,
                         update_pay,
                         reservation_pay,
                       }) {
      this.report.expenditure = plus(
        teacher_pay,
        staff_pay,
        house_pay,
        advert_pay,
        cleaner_pay,
        drink_pay,
        water_pay,
        tax_amount_pay,
        refund_pay,
        ticket_refund_pay,
        other_pay,
        update_pay,
        reservation_pay,
      );
    },
    computeProfit({ all_income, expenditure }) {
      return this.report.profit = minus(all_income, expenditure);
    },
    computeCommission() {
      const { report } = this;
      let { new_income, old_income, profit, revenue_sharing, is_generic } = report;

      if (!revenue_sharing) return;
      if (is_generic) return this.computeCommissionForGenericStore();
      const all_income = plus(new_income, old_income);

      let commission = 0;
      if (profit > 0) {// 盈利时，总部抽成 = 总收入 * 抽成比例
        let maxCommission = multipliedBy(profit, 0.4);

        commission = multipliedBy(all_income, toYuan(revenue_sharing));
        commission = Math.min(commission, maxCommission);
      } else {
        commission = multipliedBy(all_income, 0.06);
      }

      commission = decimalPlaces(commission);

      Object.assign(report, {
        commission,
        defaultCommission: commission,
        net_profit: minus(profit, commission),
      });
    },
    computeCommissionForGenericStore() {
      const { report } = this;
      let { new_income, old_income, profit, house_pay, teacher_pay, staff_pay, revenue_sharing } = report;
      const all_income = plus(new_income, old_income);
      const grossProfit = minus(all_income, house_pay, teacher_pay, staff_pay);

      let commission = 0;
      if (grossProfit <= 0) {
        commission = 1000;
      } else {
        let maxCommission = multipliedBy(grossProfit, 0.2);
        commission = multipliedBy(all_income, toYuan(revenue_sharing));
        commission = Math.min(commission, maxCommission);
        commission = Math.max(commission, 1000);
        commission = decimalPlaces(commission);
      }

      Object.assign(report, {
        commission,
        defaultCommission: commission,
        net_profit: minus(profit, commission),
      });
    },
    computeNetProfit() {
      const { report } = this;
      report.net_profit = minus(report.profit, report.commission);
    },
    addTeacherSalaries() {
      this.teacherSalaries.push({
        teacher_id: '',
        base_pay: 0,
        social_insurance: 0,
        store_insurance: 0,
        personal_insurance: 0,

        class_pay: 0,
        adult_class_pay: 0,
        child_class_pay: 0,
        major_class_pay: 0,
        private_class_pay: 0,
        leave_class_pay: 0,

        group_course_count: 0,
        adult_course_count: 0,
        child_course_count: 0,
        major_course_count: 0,
        private_course_count: 0,
        late_count: 0,
        absence_count: 0,

        adult_course_pay: 0,
        child_course_pay: 0,
        major_course_pay: 0,
        private_course_pay: 0,
        group_course_pay: 0,
        bonus: 0,
        showTip: false,
      });
    },
    addStaffSalaries() {
      this.staffSalaries.push({
        administrator_id: '',
        base_pay: 0,
        task_income: 0,
        base_pay_rate: 0,
        commission_rate: 0,
        actual_base_pay: 0,
        commission: 0,
        is_manual_actual_base_pay: false,
        is_manual_commission: false,
        personal_insurance: 0,
        social_insurance: 0,
        store_insurance: 0,
        bonus: 0,
        actual_pay: 0,
        all_pay: 0,
      });
    },
    async getStaffSalary(id, row) {
      if (!id) return;
      const { isError, data } = await getSalaryByAdministratorId({
        administrator_id: id,
        store_id: this.report.store_id,
      });
      if (isError) return;

      Object.assign(row, {
        nickname: data.nickname,
        base_pay: toYuan(data.base_pay),
        task_income: toYuan(data.task_income),
        commission_rate: toYuan(data.commission_rate),
        base_pay_rate: toYuan(data.base_pay_rate),
        social_insurance: toYuan(data.social_insurance),
        store_insurance: toYuan(data.store_insurance),
        personal_insurance: toYuan(data.personal_insurance),
        // 换了员工，之前的实发底薪/提成不再算手工值
        is_manual_actual_base_pay: false,
        is_manual_commission: false,
      });
      // 按新员工的底薪/业绩任务/比例，立即回填实发底薪和提成
      this.computeStaffActualBasePay(row);
      this.computeStaffCommission(row);
      this.computeStaffPayments(row, {});
    },
    handleSubmit(is_draft) {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.report };
        const errorMessage = this.checkAllIncome();
        if (errorMessage) return this.$message.error(errorMessage);

        postData.is_draft = is_draft;
        postData.report_date = toSecond(postData.report_date);

        // 收入
        postData.new_income = toCent(postData.new_income);
        postData.old_income = toCent(postData.old_income);
        postData.trial_income = toCent(postData.trial_income);
        postData.card_ticket_income = toCent(postData.card_ticket_income);
        postData.voucher_income = toCent(postData.voucher_income);
        postData.update_income = toCent(postData.update_income);
        postData.reservation_income = toCent(postData.reservation_income);
        postData.other_income = toCent(postData.other_income);

        postData.we_chat_income = toCent(postData.we_chat_income);
        postData.alipay_income = toCent(postData.alipay_income);
        postData.fu_zhang_gui_income = toCent(postData.fu_zhang_gui_income);
        postData.meituan_income = toCent(postData.meituan_income);
        postData.card_income = toCent(postData.card_income);
        postData.cash_income = toCent(postData.cash_income);
        postData.you_zan_income = toCent(postData.you_zan_income);
        postData.dou_yin_income = toCent(postData.dou_yin_income);
        postData.transfer_income = toCent(postData.transfer_income);
        postData.applet_income = toCent(postData.applet_income);

        postData.all_income = toCent(postData.all_income);
        postData.task_income = toCent(postData.task_income);

        // 支出
        postData.teacher_pay = toCent(postData.teacher_pay);
        postData.staff_pay = toCent(postData.staff_pay);
        postData.group_course_pay = toCent(postData.group_course_pay);
        postData.private_course_pay = toCent(postData.private_course_pay);
        postData.house_pay = toCent(postData.house_pay);
        postData.advert_pay = toCent(postData.advert_pay);
        postData.cleaner_pay = toCent(postData.cleaner_pay);
        postData.drink_pay = toCent(postData.drink_pay);
        postData.water_pay = toCent(postData.water_pay);
        postData.refund_pay = toCent(postData.refund_pay);
        postData.ticket_refund_pay = toCent(postData.ticket_refund_pay);
        postData.update_pay = toCent(postData.update_pay);
        postData.reservation_pay = toCent(postData.reservation_pay);
        postData.other_pay = toCent(postData.other_pay);
        postData.expenditure = toCent(postData.expenditure);
        postData.profit = toCent(postData.profit);
        postData.net_profit = toCent(postData.net_profit);
        postData.course_consumption_profit = minus(postData.course_consumption, postData.expenditure);
        postData.commission = toCent(postData.commission);
        postData.revenue_sharing = toCent(postData.revenue_sharing);

        // 月度总费用
        let group_course_pay = 0;
        let private_course_pay = 0;
        let adult_course_pay = 0;
        let child_course_pay = 0;
        let major_course_pay = 0;
        let bonus = 0;

        const teacher_salaries = JSON.parse(JSON.stringify(this.teacherSalaries));
        teacher_salaries.forEach(v => {
          group_course_pay = plus(group_course_pay, v.group_course_pay);
          private_course_pay = plus(private_course_pay, v.private_course_pay);
          adult_course_pay = plus(adult_course_pay, v.adult_course_pay);
          child_course_pay = plus(child_course_pay, v.child_course_pay);
          major_course_pay = plus(major_course_pay, v.major_course_pay);
          bonus = plus(bonus, v.bonus);

          v.base_pay = toCent(v.base_pay);
          v.social_insurance = toCent(v.social_insurance);
          v.store_insurance = toCent(v.store_insurance);
          v.personal_insurance = toCent(v.personal_insurance);
          v.class_pay = toCent(v.class_pay);
          v.private_class_pay = toCent(v.private_class_pay);
          v.leave_class_pay = toCent(v.leave_class_pay);

          v.group_course_count = toCent(v.group_course_count);
          v.private_course_count = toCent(v.private_course_count);
          v.late_count = toCent(v.late_count);
          v.absence_count = toCent(v.absence_count);
          v.adult_course_count = toCent(v.adult_course_count);
          v.child_course_count = toCent(v.child_course_count);
          v.major_course_count = toCent(v.major_course_count);

          // 课时费总额统一按分存储（元→分），与其他 pay 字段保持一致
          v.group_course_pay = toCent(v.group_course_pay);
          v.private_course_pay = toCent(v.private_course_pay);
          v.absence_pay = toCent(v.absence_pay);

          v.adult_course_pay = toCent(v.adult_course_pay);
          v.child_course_pay = toCent(v.child_course_pay);
          v.major_course_pay = toCent(v.major_course_pay);
          v.adult_class_pay = toCent(v.adult_class_pay);
          v.child_class_pay = toCent(v.child_class_pay);
          v.major_class_pay = toCent(v.major_class_pay);
          v.bonus = toCent(v.bonus);
          v.actual_pay = toCent(v.actual_pay);
          v.all_pay = toCent(v.all_pay);
        });
        const staff_salaries = JSON.parse(JSON.stringify(this.staffSalaries));
        staff_salaries.forEach(v => {
          v.base_pay = toCent(v.base_pay);
          v.task_income = toCent(v.task_income);
          v.commission_rate = toCent(v.commission_rate);
          v.base_pay_rate = toCent(v.base_pay_rate);
          v.actual_base_pay = toCent(v.actual_base_pay);
          v.commission = toCent(v.commission);
          v.social_insurance = toCent(v.social_insurance);
          v.store_insurance = toCent(v.store_insurance);
          v.personal_insurance = toCent(v.personal_insurance);
          v.bonus = toCent(v.bonus);
          v.actual_pay = toCent(v.actual_pay);
          v.all_pay = toCent(v.all_pay);
          // 手工编辑标记只用于前端判断，不提交给接口
          delete v.is_manual_actual_base_pay;
          delete v.is_manual_commission;
        });

        Object.assign(postData, {
          group_course_pay: toCent(group_course_pay),
          private_course_pay: toCent(private_course_pay),
          adult_course_pay: toCent(adult_course_pay),
          child_course_pay: toCent(child_course_pay),
          major_course_pay: toCent(major_course_pay),
          bonus: toCent(bonus),

          teacher_salaries,
          staff_salaries,
        });

        this.isSaving = true;
        const { isError } = await update(this.id, postData);
        this.isSaving = false;
        if (isError) return;

        RouteConfig.monthlyReportList.back();
      });
    },
    async getTeachers() {
      const { isError, data } = await getTeachers({
        store_id: this.report.store_id,
        is_brief: 1,
      });

      if (isError) return this.isLoadingError = true;

      this.teachers = data;
    },
    async show() {
      const { isError, data } = await show(this.id);

      if (isError) return this.isLoadingError = true;

      Object.assign(this, {
        youZanIncomes: data.you_zan_incomes || [],
        report: {
          add_time: data.add_time,
          store_id: data.store_id,
          report_date: toMillisecond(data.report_date),

          new_income: toYuan(data.new_income),
          old_income: toYuan(data.old_income),
          trial_income: toYuan(data.trial_income),
          card_ticket_income: toYuan(data.card_ticket_income),
          voucher_income: toYuan(data.voucher_income),
          voucher_income_count: data.voucher_income_count || 0,
          ticket_refund_pay: toYuan(data.ticket_refund_pay),
          ticket_refund_count: data.ticket_refund_count || 0,
          refund_count: data.refund_count || 0,
          update_income: toYuan(data.update_income),
          reservation_income: toYuan(data.reservation_income),
          reservation_income_valid: toYuan(data.reservation_income_valid),
          other_income: toYuan(data.other_income),
          other_income_remark: data.other_income_remark || '',

          we_chat_income: toYuan(data.we_chat_income),
          alipay_income: toYuan(data.alipay_income),
          fu_zhang_gui_income: toYuan(data.fu_zhang_gui_income),
          meituan_income: toYuan(data.meituan_income),
          card_income: toYuan(data.card_income),
          cash_income: toYuan(data.cash_income),
          you_zan_income: toYuan(data.you_zan_income),
          dou_yin_income: toYuan(data.dou_yin_income),
          transfer_income: toYuan(data.transfer_income),
          applet_income: toYuan(data.applet_income),

          all_income: toYuan(data.all_income),
          all_income_way: toYuan(data.all_income),
          expenditure: toYuan(data.expenditure),

          new_count: data.new_count || 0,
          old_count: data.old_count || 0,
          trial_count: data.trial_count || 0,
          card_ticket_income_count: data.card_ticket_income_count || 0,
          invoice_count: data.invoice_count || 0,
          update_income_count: data.update_income_count || 0,
          reservation_income_count: data.reservation_income_count || 0,
          update_pay_count: data.update_pay_count || 0,
          reservation_pay_count: data.reservation_pay_count || 0,
          other_count: data.other_count || 0,
          // total_attendance 存储值为实际值×100，直接取值回显（展示时用 toYuan 显示）
          total_attendance: data.total_attendance || 0,
          average_attendance: data.average_attendance || 0,
          course_consumption: data.course_consumption || 0,
          revenue_sharing: toYuan(data.revenue_sharing),

          teacher_pay: toYuan(data.teacher_pay),
          staff_pay: toYuan(data.staff_pay),
          house_pay: toYuan(data.house_pay),
          advert_pay: toYuan(data.advert_pay),
          cleaner_pay: toYuan(data.cleaner_pay),
          drink_pay: toYuan(data.drink_pay),
          water_pay: toYuan(data.water_pay),
          tax_amount_pay: toYuan(data.tax_amount_pay),
          update_pay: toYuan(data.update_pay),
          reservation_pay: toYuan(data.reservation_pay),
          refund_pay: toYuan(data.refund_pay),
          other_pay: toYuan(data.other_pay),
          other_pay_remark: data.other_pay_remark || '',

          profit: toYuan(data.profit),
          commission: toYuan(data.commission),
          defaultCommission: toYuan(data.commission),
          net_profit: toYuan(data.net_profit),

          is_ladder_salary: data.is_ladder_salary,
          is_has_major: data.is_has_major,
          store_revenue_sharing: toYuan(data.store_revenue_sharing),
          is_draft: data.is_draft ? 1 : 0,
          is_generic: !!data.is_generic,
        },
      });

      this.getCards();
      this.getInvoices();
      this.getUpdatePayments(1);
      this.getUpdatePayments(0);
      this.getReservationIncomes();
      this.getReservationPays();
      this.refreshTotalAttendance();
    },
    // 大课课时总人次由日总结汇总提供，进入修改页时重新拉取最新值，
    // 避免沿用添加月总结时存储的旧值（日总结修正后此处应能同步恢复）
    async refreshTotalAttendance() {
      const { isError, data } = await getAttendance({
        store_id: this.report.store_id,
        report_date: toSecond(this.report.report_date),
      });

      if (isError || !data) return this.isLoadingError = true;

      this.report.total_attendance = data.total_attendance || 0;
    },
    async getCards() {
      const { isError, data } = await getCards({
        store_id: this.report.store_id,
        report_date: toSecond(this.report.report_date),
      });

      if (isError) return this.isLoadingError = true;

      this.newCards = data.new_cards || [];
      this.oldCards = data.old_cards || [];
      this.delCards = data.del_cards || [];
      this.otherIncomes = data.other_incomes || [];
      this.new_cards_del_count = data.new_cards_del_count || 0;
      this.old_cards_del_count = data.old_cards_del_count || 0;
      if (this.newCards.length < 11) this.isShowNewCards = true;
      if (this.oldCards.length < 11) this.isShowOldCards = true;
      if (this.delCards.length < 11) this.isShowDelCards = true;
      if (this.otherIncomes.length < 11) this.isShowOtherIncomes = true;
    },
    async getInvoices() {
      const { isError, data } = await getInvoices({
        store_id: this.report.store_id,
        report_date: toSecond(this.report.report_date),
      });

      if (isError || !data) return this.isLoadingError = true;

      this.invoices = data;
      this.report.invoice_count = data.length;
      let taxAmount = 0;
      for (let i = 0; i < data.length; i++) {
        taxAmount = plus(taxAmount, data[i].tax_amount);
      }
      this.report.tax_amount_pay = toYuan(taxAmount);
      if (this.report.invoice_count < 11) this.isShowInvoices = true;
    },
    async getUpdatePayments(is_income) {
      const { isError, data } = await getUpdatePayments({
        store_id: this.report.store_id,
        report_date: toSecond(this.report.report_date),
        is_monthly: 1,
        is_income,
      });

      if (isError) return this.isLoadingError = true;

      if (is_income) {
        this.updateIncomes = data.list || [];
      } else {
        this.updatePays = data.list || [];
      }
      if (this.updateIncomes.length < 11) this.isShowUpdateIncomes = true;
      if (this.updatePays.length < 11) this.isShowUpdatePays = true;
    },
    async getReservationIncomes() {
      const { isError, data } = await getReservationIncomes({
        store_id: this.report.store_id,
        report_date: toSecond(this.report.report_date),
        is_monthly: 1,
      });

      if (isError) return this.isLoadingError = true;

      this.report.reservation_income_count = data.count || 0;
      this.reservation_income_del_count = data.reservation_income_del_count || 0;
      this.reservationIncomes = data.list || [];
      this.isShowReservationIncomes = this.reservationIncomes.length < 11;
    },
    async getReservationPays() {
      const { isError, data } = await getReservationPays({
        store_id: this.report.store_id,
        report_date: toSecond(this.report.report_date),
        is_monthly: 1,
      });

      if (isError) return this.isLoadingError = true;

      this.report.reservation_pay_count = data.count || 0;
      this.reservationPays = data.list || [];
      this.isShowReservationPays = this.reservationPays.length < 11;
    },
    async getTeacherSalaries() {
      if (this.isTeacherSalariesLoading) return;

      this.isTeacherSalariesLoading = true;
      const { isError, data } = await getTeacherSalariesByReportId(this.id);
      this.isTeacherSalariesLoading = false;

      if (isError) return this.isLoadingError = true;

      data.forEach(v => {
        v.base_pay = toYuan(v.base_pay);
        v.social_insurance = toYuan(v.social_insurance);
        v.store_insurance = toYuan(v.store_insurance);
        v.personal_insurance = toYuan(v.personal_insurance);
        v.class_pay = toYuan(v.class_pay);
        v.private_class_pay = toYuan(v.private_class_pay);
        v.leave_class_pay = toYuan(v.leave_class_pay);

        v.adult_course_pay = toYuan(v.adult_course_pay);
        v.child_course_pay = toYuan(v.child_course_pay);
        v.major_course_pay = toYuan(v.major_course_pay);
        v.group_course_pay = toYuan(v.group_course_pay);
        v.private_course_pay = toYuan(v.private_course_pay);
        v.absence_pay = toYuan(v.absence_pay);
        v.adult_class_pay = toYuan(v.adult_class_pay);
        v.child_class_pay = toYuan(v.child_class_pay);
        v.major_class_pay = toYuan(v.major_class_pay);
        v.bonus = toYuan(v.bonus);
        v.actual_pay = toYuan(v.actual_pay);
        v.all_pay = toYuan(v.all_pay);

        // 课时数字段存储为小时×100，前端回显需转为小时
        v.group_course_count = toYuan(v.group_course_count);
        v.private_course_count = toYuan(v.private_course_count);
        v.late_count = toYuan(v.late_count);
        v.absence_count = toYuan(v.absence_count);
        v.adult_course_count = toYuan(v.adult_course_count);
        v.child_course_count = toYuan(v.child_course_count);
        v.major_course_count = toYuan(v.major_course_count);
        v.showTip = false;
      });

      this.teacherSalaries = data;
    },
    async getStaffSalaries() {
      const { isError, data } = await getStaffSalariesByReportId(this.id, 1);

      if (isError) return this.isLoadingError = true;

      data.forEach(v => {
        v.base_pay = toYuan(v.base_pay);
        v.task_income = toYuan(v.task_income);
        v.commission_rate = toYuan(v.commission_rate);
        v.base_pay_rate = toYuan(v.base_pay_rate);
        v.actual_base_pay = toYuan(v.actual_base_pay);
        v.commission = toYuan(v.commission);
        v.social_insurance = toYuan(v.social_insurance);
        v.store_insurance = toYuan(v.store_insurance);
        v.personal_insurance = toYuan(v.personal_insurance);
        v.bonus = toYuan(v.bonus);
        v.actual_pay = toYuan(v.actual_pay);
        v.all_pay = toYuan(v.all_pay);
        // 先在回填时把标记定义好，后续标记变化才能驱动页面提示
        v.is_manual_actual_base_pay = false;
        v.is_manual_commission = false;
      });

      this.staffSalaries = data;
    },
    async getTeacherCourses(row) {
      if (this.isCourseLoading) return;

      this.isCourseLoading = true;
      this.isShowCourseDialog = true;
      this.courses = [];

      const { isError, data } = await getTeacherCourses({
        teacher_id: row.teacher_id,
        store_id: this.report.store_id,
        report_date: toSecond(this.report.report_date),
      });

      if (isError || !data || !data.courses || !data.courses.length) {
        this.isCourseLoading = false;
        return;
      }

      data.courses.forEach(v => {
        v.duration = Math.round((v.end_time - v.start_time) / 36);
      });
      this.courses = data.courses;
      this.isCourseLoading = false;
    },
    async showPayslip(row) {
      if (this.isCourseLoading) return;

      this.isCourseLoading = true;
      this.isShowPayslipDialog = true;

      this.base_pay = row.base_pay;
      this.all_pay = row.all_pay;
      this.actual_pay = row.actual_pay;
      this.social_insurance = row.social_insurance;
      this.store_insurance = row.store_insurance;
      this.personal_insurance = row.personal_insurance;
      this.bonus = row.bonus;

      this.group_course_count = row.group_course_count;
      this.adult_course_count = row.adult_course_count;
      this.child_course_count = row.child_course_count;
      this.major_course_count = row.major_course_count;
      this.private_course_count = row.private_course_count;
      this.absence_count = row.absence_count;

      this.adult_course_leave_count = 0;
      this.child_course_leave_count = 0;
      this.major_course_leave_count = 0;
      this.personal_course_leave_count = 0;

      this.group_class_pay = row.class_pay;
      this.adult_class_pay = row.adult_class_pay;
      this.child_class_pay = row.child_class_pay;
      this.major_class_pay = row.major_class_pay;
      this.private_class_pay = row.private_class_pay;
      this.leave_class_pay = row.leave_class_pay;

      this.adult_bonus = row.adult_bonus;
      this.child_bonus = row.child_bonus;
      this.major_bonus = row.major_bonus;

      this.adult_bonus_count = [];
      this.child_bonus_count = [];
      this.major_bonus_count = [];

      this.adult_student_average = 0;
      this.child_student_average = 0;
      this.major_student_average = 0;
      this.personal_student_average = 0;

      const { isError, data } = await getTeacherCourses({
        teacher_id: row.teacher_id,
        store_id: this.report.store_id,
        report_date: toSecond(this.report.report_date),
      });

      if (isError || !data || !data.courses || !data.courses.length) {
        this.isCourseLoading = false;
        return;
      }

      this.adult_bonus_count = data.adult_bonus_count.length ? data.adult_bonus_count : [];
      this.child_bonus_count = data.child_bonus_count.length ? data.child_bonus_count : [];
      this.major_bonus_count = data.major_bonus_count.length ? data.major_bonus_count : [];

      this.adult_course_leave_count = data.adult_course_leave_count || 0;
      this.child_course_leave_count = data.child_course_leave_count || 0;
      this.major_course_leave_count = data.major_course_leave_count || 0;
      this.personal_course_leave_count = data.personal_course_leave_count || 0;
      this.adult_bonus = toYuan(data.adult_bonus);
      this.child_bonus = toYuan(data.child_bonus);
      this.major_bonus = toYuan(data.major_bonus);
      this.group_student_average = data.group_student_average || 0;
      this.adult_student_average = data.adult_student_average || 0;
      this.child_student_average = data.child_student_average || 0;
      this.major_student_average = data.major_student_average || 0;
      this.personal_student_average = data.personal_student_average || 0;
      this.isCourseLoading = false;
    },
    copyPayslip() {
      copyToClipboard({ element: this.$refs.payslip });
    },
  },
};
</script>

<style src="./add.css" lang="css" scoped/>
